var $06f6c7e2c1611567$exports = {};
$06f6c7e2c1611567$exports = {
    "maximum": `M\xe1ximo`,
    "minimum": `M\xednimo`
};


export {$06f6c7e2c1611567$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
